import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { fetchPlayerUsers, fetchInstitutionUsers, usersSelector } from 'reducers/users';
import { RequestStateHelper } from 'reducers/createRequestReducer';
import { connect } from 'react-redux';
import { Typography } from '@material-ui/core';
import FullWidthLoader from 'ui/base/FullWidthLoader';
import { playersSelector } from 'reducers/players';
import ExitCareCircleButton from '../players/ExitCareCircleButton';
import { LocaleConsumer } from 'containers/locale/LocaleProvider';

const styles = {
    userItem: {
        marginBottom: '6px',
    },
};

class PlayerUsersInstitutionList extends React.Component {
    componentDidMount() {
        const { playerId, institutionId } = this.props;
        if (playerId) this.props.fetchPlayerUsers(playerId);
        if (institutionId) this.props.fetchUsers(institutionId);
    }

    componentDidUpdate(prevProps) {
        const { institutionId, users } = this.props;

        const justFetchedInstitutionId = institutionId && institutionId !== prevProps.institutionId;
        
        if (justFetchedInstitutionId && users.length === 0) {
            this.props.fetchUsers(institutionId);  
        }
    }

    renderList() {
        const { classes, users, institutionId, player, currentUser } = this.props;
        
        if (users.length === 1) {
            return (
                <LocaleConsumer>
                    {({ getTranslation }) => <Typography>{getTranslation('player_users_list_empty')}</Typography>}
                </LocaleConsumer>
            );
        }

        return (
            <div>
                <ul>
                    {users
                        .filter(user => user.id !== institutionId && user.id !== player.main_user_id)
                        .map(user => (
                            <li key={user.id} className={classes.userItem}>
                                <div>
                                    <Typography style={{ fontStyle: user.display_name.length ? 'normal' : 'italic' }}>
                                        {user.display_name.length ? `${user.display_name} (${user.email})` : `${user.email}`}
                                    </Typography>
                                    {player.main_user_id === currentUser.id && (
                                        <ExitCareCircleButton user={user} player={player} />
                                    )}
                                </div>
                            </li>
                        ))
                    }
                </ul>
            </div>
        );
    }

    render() {
        const { classes, isLoading } = this.props;

        return (
            <div>
                {isLoading && <FullWidthLoader />}
                {!isLoading && this.renderList()}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const institutionUsers = usersSelector.getInstitutionUsers(state);
    const playerUsers = usersSelector.getCurrentPlayerUsers(state);

    const filteredUsers = institutionUsers.filter(user =>
        playerUsers.some(playerUser => playerUser.id === user.id)
    )

    return {
        users: filteredUsers,
        isLoading: RequestStateHelper.isLoading(usersSelector.getInstitutionUsersState(state)),
        player: playersSelector.getPlayer(state, ownProps.playerId),
        currentUser: usersSelector.getCurrentUser(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchUsers: (institutionId) => {
            dispatch(fetchInstitutionUsers(institutionId));
        },
        fetchPlayerUsers: (playerId) => {
            dispatch(fetchPlayerUsers(playerId));
        }
    };
}

export default withStyles(styles)(
    connect(mapStateToProps, mapDispatchToProps)(PlayerUsersInstitutionList)
);